import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { getRelativeTime } from '../utils/dateUtils';

interface NotificationCardProps {
  title: string;
  content: string;
  createdTime: string;
  to?: string | null;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  title,
  content,
  createdTime,
  to
}) => {
  const relativeTime = getRelativeTime(createdTime);
  
  // to가 null이거나 빈 문자열이면 CMS에서 보낸 것으로 간주하여 줄바꿈 무시
  const isCmsNotification = !to || to === '';
  
  // body에서 줄바꿈 감지하여 나누기 (to에 값이 있을 때만)
  const bodyParts = isCmsNotification ? [content] : content.split('\n');
  const hasLineBreak = !isCmsNotification && bodyParts.length > 1;
  const firstPart = bodyParts[0];
  const secondPart = hasLineBreak ? bodyParts.slice(1).join('\n') : '';

  return (
    <Box>
      <Box
        sx={{
          padding: '16px'
        }}
      >
        {/* 제목 - 가장 위로 이동 */}
        <Typography
          sx={{
            color: '#262626',
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: 1.2,
            marginBottom: '8px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
            textAlign: 'left'
          }}
        >
          {title}
        </Typography>

        {/* 내용 첫 번째 부분 */}
        <Typography
          sx={{
            color: '#666666',
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: 1.4,
            marginBottom: hasLineBreak ? '4px' : '8px',
            wordBreak: 'break-word',
            textAlign: 'left'
          }}
        >
          {firstPart}
        </Typography>

        {/* 내용 두 번째 부분 (줄바꿈이 있을 때만 표시) */}
        {hasLineBreak && secondPart && (
          <Typography
            sx={{
              color: '#666666',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: 1.4,
              marginBottom: '8px',
              wordBreak: 'break-word',
              textAlign: 'left'
            }}
          >
            {secondPart}
          </Typography>
        )}

        {/* 시간 */}
        <Typography
          sx={{
            color: '#b3b3b3',
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: 1.2,
            textAlign: 'left'
          }}
        >
          {relativeTime}
        </Typography>
      </Box>
      
      {/* 디바이더 */}
      <Divider sx={{ backgroundColor: '#f3f3f3' }} />
    </Box>
  );
};

export default NotificationCard;
